import { Component, OnInit, Input } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatSnackBar } from '@angular/material';
import { ReferenceCodeService } from '@app/admin/reference-code/reference-code.service';
import { ApplicationService } from '@app/applications/application.service';
import { ApplicationAccessSpecifier, LoanApplication } from '@app/applications/applications.model';
import { NameValueDto } from '@app/loan-od-accounts/name-value-dto';
@Component({
  selector: 'eng-credit-loan-recommendation',
  templateUrl: 'credit-loan-recommendation.template.html',
  styleUrls: ['../../application-details.styles.scss', './credit-loan-recommendation.scss']
})
export class CreditLoanRecommendationComponent implements OnInit {

  @Input()
  application: LoanApplication;

  @Input()
  menuCode: string;

  menuItemAllowAccess: boolean;
  isFormDisabled: boolean;
  allowAccess: boolean;
  applicationAccessSpecifiers: ApplicationAccessSpecifier[];
  menuItemAccessSpecifier: ApplicationAccessSpecifier;

  loanRecommendationCompositeDto: any = {};
  loanRecommendationForm: FormGroup;
  riskAssessmentData: any = {};
  livingStandards: NameValueDto[];
  characters: NameValueDto[];

  constructor(private applicationService: ApplicationService,
    private formBuilder: FormBuilder,
    private referenceCodeService: ReferenceCodeService,
    private _snackbar: MatSnackBar
  ) {
    this.loanRecommendationForm = this.formBuilder.group({
      livingStandard: [''],
      character: ['']
    });
    this.allowAccess = this.applicationService.allowAccess;
  }

  ngOnInit() {
    this.isFormDisabled = true;
    this.getRefCodes();
    this.getMenuItemAccess();
    this.getRiskAssessment();
  }

  getRefCodes() {
    this.referenceCodeService.getShortRefCodes('living_standard').subscribe((response: any) => {
      this.livingStandards = response.living_standard;
    });

    this.referenceCodeService.getShortRefCodes('character').subscribe((response: any) => {
      this.characters = response.character;
    });
  }

  getSalesLoanRecommendation() {
    let livingStandard = this.loanRecommendationForm.getRawValue().livingStandard;
    let character = this.loanRecommendationForm.getRawValue().character;
    this.applicationService.getCreditLoanRecommendation(this.application.uid, livingStandard, character).subscribe((response: any) => {
      if (response.body && response.body.loanRecommendation) {
        this.loanRecommendationCompositeDto = response.body.loanRecommendation;
      }
    });
  }

  getRiskAssessment() {
    this.applicationService.retiveRiskAssessmentData(this.application.uid).subscribe((response: any) => {
      this.riskAssessmentData = response.body;
      this.loanRecommendationForm.patchValue({
        livingStandard: this.riskAssessmentData.livingStandard,
        character: this.riskAssessmentData.character
      })
      this.loanRecommendationForm.disable();
      this.getSalesLoanRecommendation();
    });
  }

  saveLoanRecommendationDetails() {
    if (!this.isFormDisabled) {
      this.riskAssessmentData.livingStandard = this.loanRecommendationForm.value.livingStandard;
      this.riskAssessmentData.character = this.loanRecommendationForm.value.character;
      this.applicationService.saveRisk(this.application.uid, this.riskAssessmentData).subscribe((response: any) => {
        const payload = {
          loanRecommendation: this.loanRecommendationCompositeDto
        };
        this.applicationService.saveLoanRecommendation(this.application.uid, payload).toPromise().then(
          (_success) => {
            this._snackbar.open("Loan recommendation updated successfully", "Close", {
              duration: 4000,
            });
            this.isFormDisabled = true;
            this.loanRecommendationForm.disable();
            this.getSalesLoanRecommendation();
          },
        )
      });
    }
  }

  enableDisableForm() {
    this.isFormDisabled = false;
    this.loanRecommendationForm.enable();
  }

  cancelForm() {
    this.isFormDisabled = true;
    this.getRiskAssessment();
    this.loanRecommendationForm.disable();
  }

  getMenuItemAccess() {
    this.applicationService.getApplicationAccessModifiers(this.application.uid)
      .subscribe((response) => {
        this.applicationAccessSpecifiers = response.body;
        this.menuItemAccessSpecifier = this.applicationAccessSpecifiers
          .find(accessSpecifier => accessSpecifier.category === this.menuCode);
        if (this.menuItemAccessSpecifier) {
          this.menuItemAllowAccess = this.menuItemAccessSpecifier.allowAccess;
        }
      });
  }

}